import Main from './PaymentServiceTemplatesMain'
import New from './PaymentServiceTemplatesNew'
import Edit from './PaymentServiceTemplatesEdit'

const PaymentServiceTemplates = {
  Main,
  New,
  Edit,
}

export default PaymentServiceTemplates
